








































import Vue from 'vue';
import NavbarComp from '../modules/NavbarComp.vue';
import FooterComp from '../modules/FooterComp.vue';
import ListComp from '../modules/ListComp.vue';
import { APIClient } from '../../libs/ApiClient';

export default Vue.extend({
  name: 'Owner',
  props: ['address'],
  components: {
    NavbarComp,
    FooterComp,
    ListComp,
  },
  created() {
    this.getApostilles();
    this.getNamespaces();
  },
  methods: {
    async getApostilles() {
      this.histories = await APIClient.getApostillesByAddress(this.address);
      this.isLoading = false;
    },
    async getNamespaces() {
      this.namespaces = await APIClient.getNamespaces(this.address);
    },
    hasNamespaces() {
      return this.namespaces && this.namespaces.length > 0;
    }
  },
  data() {
    return {
      isLoading: true,
      rowsPerPageItems: [10, 25, { "text":"$vuetify.dataIterator.rowsPerPageAll","value":-1 }],
      hideActions: false,
      histories: [],
      namespaces: [],
      isShowSearch: false,
    };
  }
});
